export default "__VITE_ASSET__CFcWmcVH__"